import CircularProgress from '@mui/material/CircularProgress'

import { FullSizeCenteredFlexBox } from 'components/styled'

function Loading() {
  return (
    <FullSizeCenteredFlexBox
      sx={{
        mt: 40,
      }}
    >
      <CircularProgress />
    </FullSizeCenteredFlexBox>
  )
}

export default Loading
